import { type FC, useEffect } from "react";

import { usePanelLayoutStore } from "./stores/panel-store.ts";
import type { Tab } from "./types.ts";

export const FixedPanelTab: FC<Tab> = (props) => {
  const addTab = usePanelLayoutStore((state) => state.addTab);

  useEffect(() => {
    addTab(props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
